package com.esoris.kmpmoout.features.product

import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val productModule = module {

    viewModelOf(::ProductViewModel)

}
